<template>
  <v-dialog v-model="dialog" width="800" :persistent="true">
    <template v-slot:activator="{ on }">
      <v-btn color="primary" v-on="on">
        {{ 'app.add_tag' | trans }}
      </v-btn>
    </template>
    <v-card>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>
          {{
            (!!tagId ? 'app.edit_tag' : 'app.add_tag') | trans
          }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark small @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout wrap align-center>
              <v-flex xs6>
                <v-text-field
                    :label="'app.name' | trans"
                    required
                    v-model="tag.name"
                    :rules="rules.name"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 c->
                    <v-select v-model="tag.type"
                              :rules="rules.type"
                              item-text="text"
                              item-value="value"
                              required
                              :disabled="!!tagId"
                              :readonly="!!tagId"
                              :items="types"
                              :label="`app.type` | trans"
                    ></v-select>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="close">
          {{ 'app.close' | trans }}
        </v-btn>
        <v-btn color="primary" @click="save" :disabled="!valid"
               :loading="loading">
          {{ 'app.save' | trans }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import RulesBuilder from "../utils/rulesBuilder";
import {trans} from "../app";

export default {
  data: function () {
    return {
      rulesBuilder: null,
      dialog: false,
      valid: false,
      loading: false,
      tagId: null,
      tag: {
        name: '',
        type: '',
      },
      types: [
        {text: trans('page.tags.diet'), value: 'diet'},
        {text: trans('page.tags.equipment'), value: 'equipment'},
        {text: trans('page.tags.meal'), value: 'meal'},
        {text: trans('page.tags.tag'), value: 'tag'},
      ]
    }
  },
  props: {
    currentTag: Object,
  },
  created() {
    this.rulesBuilder = new RulesBuilder();
  },
  computed: {
    rules() {
      return {
        name: this.rulesBuilder.addRequiredRule(trans('app.name'))
            .addMaxLengthRule(trans('app.name'), 255)
            .getRules(),
        type: this.rulesBuilder.addRequiredRule(trans('app.type'))
            .getRules(),
      }
    }
  },
  watch: {
    currentTag: function (tag) {
      if (tag === null) {
        this.tagId = null;
        this.tag.name = '';
        this.tag.type = '';
      } else {
        this.tagId = tag.id;
        this.tag.name = tag.name
        this.tag.type = tag.type
      }
    }
  },
  methods: {
    open: function () {
      this.$refs.form.reset();
      this.tagId = null;
      this.dialog = true;
    },
    close: function () {
      this.dialog = false;
      this.$refs.form.reset();
      this.$emit('tag_closed');
    },
    save: async function () {
      if (this.$refs.form.validate() === false) {
        return;
      }

      this.loading = true;
      if (this.tagId === null) {
        try {
          await axios.post('/v2/food-tags', this.tag);
          this.$toast.success(trans('app.saved'));
        } catch (e) {
          this.$toast.error(trans('app.save_failed'));
          this.loading = false;
          return;
        }
      } else {
        const tagId = this.tagId;
        try {
          await axios.patch(`/v2/food-tags/${tagId}`, this.tag);
          this.$toast.success(trans('app.saved'));
        } catch (e) {
          this.$toast.error(trans('app.save_failed'));
          this.loading = false;
          return;
        }
      }
      this.$emit('tag_stored');
      this.close();
      this.loading = false;
    },
  }
}
</script>
